import hero from "./assets/hero.jpg"
import thumbnailHero from "./assets/thumbnailHero.jpg"


export const PostbitsData = {
    title: "Developing and Studying a Connected Digital Display System",
    heroImage: hero,
    thumbnailImage:hero
}